import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPageAdd"><Path d="M12.5 21.5H4.5V2.5H19.5V12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18.5 15.5V18.5V21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 18.5H18.5H21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPageAdd;
